var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoLogin({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "273.422px",
    height: "63.266px",
    preserveAspectRatio: "xMidYMid meet",
    "data-bbox": "18.3 14.287 387 71.513",
    viewBox: "18.3 14.287 387 71.513",
    xmlns: "http://www.w3.org/2000/svg",
    "data-type": "color",
    role: "presentation",
    "aria-hidden": "true",
    "aria-label": "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.3 24.4c0 4.6 3.7 8.3 8.3 8.3h14.7l17.9 43.9c1.3 3.3 4.9 5.5 8.9 5.5h10.3l-20-49.3h13.2c4.6 0 8.4-3.7 8.4-8.4v-8.3H18.3v8.4Z",
    fill: "#4ab8aa",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.9 16.1H86.1v8.2c0 4.7 3.8 8.5 8.5 8.5H119c13.4 0 23.1 16.2 10.5 30-1.5 1.7-3.7 2.6-6 2.6H102V49.1h-.2c-8.6 0-15.6 7-15.6 15.6v17.4h41.6c4.9 0 9.6-2.1 12.8-5.8 24.9-27.8 5.4-60.2-21.5-60.2",
    fill: "#4ab8aa",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.8 53.8V22.6h11.5v-6.4h-30.7v6.4h11.5v31.2z",
    fill: "#ffffff",
    "data-color": 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.3 32.2v-6.8c-.4 0-.8-.2-1.2-.2h-1.3c-1.5 0-3 .4-4.2 1.3-1.3 1-2.2 2.4-2.6 4h-.3v-4.9h-7.3v28.2h7.6v-16c0-1.1.2-2.1.8-3.1.5-.9 1.3-1.6 2.2-2.1 1-.5 2-.8 3.1-.7h1.8q.75 0 1.5.3",
    fill: "#ffffff",
    "data-color": 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M228.3 25.6v28.2h-7.6V25.6z",
    "data-color": 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.5 21.9c1.1 0 2.1-.4 2.9-1.1s1.2-1.7 1.2-2.7-.4-2.1-1.2-2.7c-.8-.7-1.8-1.2-2.9-1.1-1.1 0-2.1.4-2.9 1.1s-1.2 1.7-1.2 2.7.4 2 1.2 2.7 1.8 1.2 2.9 1.1",
    fill: "#ffffff",
    "data-color": 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M242.3 16.2v37.5h-7.6V16.2z",
    "data-color": 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.6 27.1c-4.6-2.4-10.1-2.4-14.7 0-2 1.2-3.7 3-4.8 5.1-1.2 2.4-1.7 5-1.7 7.6s.5 5.2 1.7 7.6c1.1 2.1 2.7 3.9 4.8 5.1 4.6 2.4 10.1 2.4 14.7 0 2-1.2 3.7-3 4.8-5.1 1.2-2.4 1.7-5 1.7-7.6s-.5-5.3-1.7-7.6c-1.1-2.1-2.7-3.9-4.8-5.1m-1.9 17.1c-.4 1.2-1.1 2.3-2 3.1-1 .8-2.2 1.2-3.4 1.1-1.2 0-2.4-.4-3.4-1.1-.9-.8-1.6-1.9-2-3.1-.9-2.9-.9-6 0-8.8.4-1.2 1.1-2.2 2-3 1-.8 2.1-1.2 3.4-1.1 1.2 0 2.4.4 3.4 1.1 1 .8 1.7 1.9 2 3.1.9 2.9.9 6 0 8.8",
    fill: "#ffffff",
    "data-color": 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.8 45.1c1.5-3.1 2.3-6.6 2.2-10.1 0-3.5-.7-6.9-2.2-10-1.4-2.7-3.6-5-6.3-6.4-3-1.6-6.3-2.3-9.7-2.3h-13.3v37.5h13.2c3.4 0 6.8-.7 9.8-2.3 2.7-1.5 4.9-3.7 6.3-6.5m-6.7-3.1c-.7 1.7-2 3.1-3.7 4-1.9.9-4 1.4-6.1 1.3h-5.1V22.9h5.2c2.1 0 4.2.4 6 1.3 1.6.9 2.9 2.3 3.7 4q1.35 3.3 1.2 6.9c0 2.4-.3 4.7-1.2 6.9",
    fill: "#ffffff",
    "data-color": 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.5 27.1c-4.6-2.4-10.1-2.4-14.7 0-2 1.2-3.7 3-4.8 5.1-1.2 2.4-1.7 5-1.7 7.6s.5 5.2 1.7 7.6c1.1 2.1 2.7 3.9 4.8 5.1 4.6 2.4 10.1 2.4 14.7 0 2-1.2 3.7-3 4.8-5.1 1.2-2.4 1.7-5 1.7-7.6s-.5-5.3-1.7-7.6c-1.1-2.1-2.7-3.9-4.8-5.1m-1.9 17.1c-.4 1.2-1.1 2.3-2 3.1-1 .8-2.2 1.2-3.4 1.1-1.2 0-2.4-.4-3.4-1.1-.9-.8-1.6-1.9-2-3.1-.9-2.9-.9-6 0-8.8.4-1.2 1.1-2.2 2-3 1-.8 2.1-1.2 3.4-1.1 1.2 0 2.4.4 3.4 1.1 1 .8 1.7 1.9 2 3 .9 2.9.9 6 0 8.8",
    fill: "#ffffff",
    "data-color": 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.7 45.5q-.45.9-1.2 1.5c-.5.4-1 .8-1.6 1s-1.3.3-2 .3c-1.2 0-2.4-.4-3.4-1.1-1-.8-1.7-1.9-2.1-3-.5-1.4-.7-2.9-.7-4.4s.2-3 .7-4.5q.6-1.8 2.1-3c1-.7 2.2-1.1 3.4-1.1.7 0 1.3.1 2 .3.6.2 1.1.5 1.6.9q.75.6 1.2 1.5c.3.6.6 1.3.7 2l7-1.3q-.3-2.1-1.5-3.9c-.7-1.2-1.6-2.2-2.7-2.9-1.1-.8-2.4-1.5-3.8-1.9-1.5-.4-3-.7-4.6-.7-2.6 0-5.1.6-7.3 1.8-2 1.2-3.7 3-4.8 5.1-1.2 2.4-1.7 5-1.7 7.6s.5 5.2 1.7 7.6c1.1 2.1 2.7 3.9 4.8 5.1 2.2 1.3 4.8 1.9 7.3 1.8 1.6 0 3.1-.2 4.6-.7 1.4-.4 2.6-1.1 3.8-1.9q1.65-1.2 2.7-3c.7-1.2 1.2-2.6 1.5-4l-7-1.3c-.1.7-.3 1.4-.7 2",
    fill: "#ffffff",
    "data-color": 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.3 53.2c1.7-.7 3.3-1.8 4.4-3.2s1.6-3.1 1.6-4.8c0-1.8-.7-3.6-2-4.9-1.7-1.4-3.8-2.4-6.1-2.7l-5.1-1c-1-.1-2-.5-2.8-1.1-.5-.4-.8-1.1-.8-1.8 0-.9.5-1.7 1.3-2.1.9-.5 2-.8 3.1-.8q1.8 0 3.3.9c.8.6 1.4 1.4 1.7 2.4l6.7-1.2c-.3-1.5-1-2.9-2-4-1.1-1.2-2.4-2.1-4-2.6-1.9-.6-3.8-1-5.8-.9-2.1 0-4.2.3-6.2 1.1-1.6.6-3.1 1.6-4.1 3-1 1.3-1.5 3-1.5 4.7 0 1.9.7 3.8 2 5.2 1.7 1.5 3.8 2.5 6.1 2.8l4.9 1c1 .2 1.9.5 2.7 1.1.6.4.9 1.1.9 1.8 0 .9-.5 1.7-1.2 2.1-1 .6-2.2.9-3.4.8-1.3 0-2.6-.3-3.7-1-1-.7-1.7-1.8-1.9-2.9l-7 1.2q.45 2.55 2.1 4.5c1.2 1.3 2.6 2.2 4.3 2.8 4.1 1.4 8.5 1.3 12.6-.2",
    fill: "#ffffff",
    "data-color": 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.3 16.2v.1zh-.1Z",
    fill: "#000000",
    "data-color": 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.6 69.2 166.9 82h1.3l1.4-3.8h5.6l1.4 3.8h1.3l-4.7-12.8h-1.4Zm3.1 7.9h-4.8l1.2-3.5c.2-.4.3-1 .5-1.6q.3-.75.6-1.8.3 1.05.6 1.8c.2.6.4 1.2.6 1.6z",
    fill: "#ffffff",
    "data-color": 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M181.2 69.2V82H180V69.2z",
    "data-color": 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M189.6 75.1v1.1h-5.4v-1.1z",
    "data-color": 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.8 76.1h5.9V75h-5.9v-4.7h6.3v-1.1h-7.5V82h7.6v-1.1h-6.4z",
    fill: "#ffffff",
    "data-color": 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.7 72.7c-1.2-.6-2.6-.5-3.7.2-.5.3-.8.8-1.1 1.3v-1.8h-1.1V82h1.2v-6c0-.5.1-1 .3-1.4s.6-.7 1-.9.9-.3 1.4-.3c.7 0 1.3.2 1.8.7s.7 1.2.7 1.9v6.1h1.2v-6.2c0-.7-.1-1.3-.4-1.9q-.45-.75-1.2-1.2",
    fill: "#ffffff",
    "data-color": 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.1 72.7c-.5-.3-1.1-.4-1.7-.4-.7 0-1.4.2-1.9.6-.5.3-.8.8-1 1.3v-4.9h-1.2v12.8h1.2v-6c0-.5.1-1 .3-1.4s.6-.7 1-.9.9-.3 1.4-.3c.7 0 1.3.2 1.8.7s.7 1.2.7 1.9v6.1h1.2V76c0-.7-.1-1.3-.4-1.9q-.45-.75-1.2-1.2",
    fill: "#ffffff",
    "data-color": 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.2 72.9c-.3-.2-.7-.4-1.1-.5-.4 0-.8-.1-1.2-.2-.5 0-1 0-1.5.2-.5.1-.9.4-1.3.7s-.7.8-.9 1.3l1.1.4c.1-.3.3-.5.5-.7q.3-.3.9-.6c.4-.1.8-.2 1.2-.2s.8 0 1.2.2c.3.2.6.4.8.7s.3.7.3 1.1v.2c0 .2-.1.4-.3.5-.3.1-.6.2-.9.2l-1.4.2c-.5 0-1 .2-1.5.3-.4.1-.8.3-1.2.5-.3.2-.6.5-.8.8q-.3.6-.3 1.2c0 .6.1 1.1.4 1.6.3.4.7.8 1.1 1 .5.2 1 .3 1.6.3.5 0 .9 0 1.4-.2.4-.2.7-.4 1-.6s.5-.5.6-.8V82h1.1v-6.5c0-.5 0-1.1-.3-1.6-.2-.4-.5-.7-.8-1m.3 5.4c0 .5-.1 1-.4 1.4-.2.4-.6.8-1 1-.5.3-1 .4-1.5.4-.4 0-.8 0-1.1-.2-.3-.1-.6-.3-.8-.6s-.3-.6-.3-1c0-.3 0-.7.3-.9q.3-.45.9-.6c.4-.2.9-.3 1.4-.3h.7c.3 0 .5 0 .8-.1.2 0 .4 0 .7-.2.2 0 .3-.1.4-.2v1.4Z",
    fill: "#ffffff",
    "data-color": 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.1 72.7c-1.2-.6-2.6-.5-3.7.2-.5.3-.8.8-1.1 1.3v-1.8h-1.1V82h1.2v-6c0-.5.1-1 .3-1.4s.6-.7 1-.9.9-.3 1.4-.3c.7 0 1.3.2 1.8.7s.7 1.2.7 1.9v6.1h1.2v-6.2c0-.7-.1-1.3-.4-1.9q-.45-.75-1.2-1.2",
    fill: "#ffffff",
    "data-color": 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.7 80c-.1.2-.3.4-.5.6s-.5.3-.8.4-.7.2-1 .2c-.6 0-1.2-.2-1.7-.5-.5-.4-.8-.9-1-1.4-.5-1.3-.5-2.7 0-3.9.2-.6.6-1 1-1.4.5-.4 1.1-.6 1.7-.5.3 0 .7 0 1 .2.3.1.5.2.8.4.2.2.4.4.5.6l.3.6 1.1-.3c-.1-.3-.3-.6-.5-.9s-.5-.6-.8-.8-.7-.4-1.1-.6c-.4-.1-.9-.2-1.3-.2-.8 0-1.6.2-2.2.6q-1.05.6-1.5 1.8c-.4.8-.6 1.7-.5 2.6 0 .9.2 1.8.5 2.6.3.7.8 1.3 1.5 1.7s1.4.6 2.2.6c.9 0 1.7-.3 2.5-.8.3-.2.6-.5.8-.8s.4-.6.5-.9l-1.1-.3c0 .2-.2.4-.3.6",
    fill: "#ffffff",
    "data-color": 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.1 73.4c-.4-.4-.8-.7-1.3-.9q-.75-.3-1.5-.3c-.8 0-1.6.2-2.2.6s-1.2 1.1-1.5 1.8c-.4.8-.5 1.7-.5 2.6s.2 1.8.5 2.6c.3.7.9 1.3 1.5 1.8.7.4 1.5.7 2.3.6.6 0 1.2 0 1.7-.3.5-.2.9-.5 1.2-.8s.6-.7.7-1.1l-1.1-.4c-.1.3-.3.6-.5.8q-.3.3-.9.6c-.4.1-.8.2-1.2.2-1.2 0-2.4-.7-2.8-1.8-.3-.6-.4-1.2-.4-1.8h7.1v-.5c0-.7 0-1.4-.3-2.1q-.3-.9-.9-1.5m-5.8 3.1c0-.5.1-1 .4-1.5.2-.5.6-.9 1.1-1.3.5-.3 1-.5 1.6-.5s1.1.1 1.6.5c.4.3.8.8 1 1.3q.3.75.3 1.5z",
    fill: "#ffffff",
    "data-color": 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.2 74.3c-.1-.3-.3-.6-.5-.9-.3-.3-.6-.6-.9-.8q-.75-.3-1.5-.3c-.7 0-1.5.2-2.1.6s-1.1 1-1.4 1.7c-.3.8-.5 1.7-.5 2.6s.1 1.8.5 2.6c.3.7.8 1.3 1.4 1.7q.9.6 2.1.6c.5 0 1 0 1.5-.3.4-.2.7-.5.9-.8l.6-.9h.1v1.8h1.1V69.1h-1.2v5.1Zm-.3 5c-.2.5-.5 1-1 1.4-.5.3-1 .5-1.6.5s-1.1-.2-1.6-.5c-.5-.4-.8-.9-1-1.4-.5-1.3-.5-2.7 0-4 .2-.5.5-1 1-1.4s1-.5 1.6-.5 1.1.2 1.6.5c.5.4.8.8 1 1.4s.4 1.3.3 2c0 .7-.1 1.4-.3 2",
    fill: "#ffffff",
    "data-color": 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.7 78c0 .2-.2.4-.3.7s-.2.5-.3.8l-.3.9v.3-.3c-.2-.3-.3-.6-.4-.9 0-.3-.2-.6-.3-.8s-.2-.5-.3-.7l-3.6-8.8h-1.7V82h1.2V70.5c0 .2.2.4.2.6.1.4.2.7.4 1l.3.9c.1.3.2.5.3.7l3.4 8.1h1.1l3.3-8.1c0-.2.2-.5.3-.8l.3-.9c.1-.3.2-.7.4-1 0-.2.1-.4.2-.6V82h1.2V69.2h-1.7l-3.6 8.8Z",
    fill: "#ffffff",
    "data-color": 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.7 73.4c-.4-.4-.8-.7-1.3-.9q-.75-.3-1.5-.3c-.8 0-1.6.2-2.2.6s-1.2 1.1-1.5 1.8c-.4.8-.5 1.7-.5 2.6s.2 1.8.5 2.6c.3.7.9 1.3 1.5 1.8.7.4 1.5.7 2.3.6.6 0 1.2 0 1.7-.3.5-.2.9-.5 1.2-.8s.6-.7.7-1.1l-1.1-.4c-.1.3-.3.6-.5.8q-.3.3-.9.6c-.4.1-.8.2-1.2.2-1.2 0-2.4-.7-2.8-1.8-.3-.6-.4-1.2-.4-1.8h7.1v-.5c0-.7 0-1.4-.3-2.1q-.3-.9-.9-1.5m-5.7 3.1c0-.5.1-1 .4-1.5.2-.5.6-.9 1.1-1.3.5-.3 1-.5 1.6-.5s1.1.1 1.6.5c.4.3.8.8 1 1.3q.3.75.3 1.5H296Z",
    fill: "#ffffff",
    "data-color": 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.9 74.3c-.1-.3-.3-.6-.5-.9-.3-.3-.6-.6-.9-.8q-.75-.3-1.5-.3c-.7 0-1.5.2-2.1.6s-1.1 1-1.4 1.7c-.3.8-.5 1.7-.5 2.6s.2 1.8.5 2.6c.3.7.8 1.3 1.4 1.7q.9.6 2.1.6c.5 0 1 0 1.5-.3.4-.2.7-.5.9-.8l.6-.9h.1v1.8h1.1V69.1H312v5.1Zm-.3 5c-.2.5-.5 1-1 1.4-.5.3-1 .5-1.6.5s-1.1-.2-1.6-.5c-.5-.4-.8-.9-1-1.4-.5-1.3-.5-2.7 0-4 .2-.5.5-1 1-1.4s1-.5 1.6-.5 1.1.2 1.6.5c.5.4.8.8 1 1.4s.4 1.3.3 2c0 .7-.1 1.4-.3 2",
    fill: "#ffffff",
    "data-color": 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M317.2 72.4V82H316v-9.6z",
    "data-color": 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.6 69c-.2 0-.4 0-.6.2-.3.3-.3.8 0 1.1s.9.3 1.2 0 .3-.8 0-1.1c-.2-.2-.4-.2-.6-.2",
    fill: "#ffffff",
    "data-color": 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.2 80c-.1.2-.3.4-.5.6q-.75.6-1.8.6c-.6 0-1.2-.2-1.7-.5-.5-.4-.8-.9-1-1.4-.5-1.3-.5-2.7 0-3.9.2-.6.6-1 1-1.4.5-.4 1.1-.6 1.7-.5.3 0 .7 0 1 .2.3.1.5.2.8.4.2.2.4.4.5.6l.3.6 1.1-.3c-.1-.3-.3-.6-.5-.9s-.5-.6-.8-.8c-.7-.5-1.6-.8-2.4-.8s-1.6.2-2.2.6q-1.05.6-1.5 1.8c-.4.8-.6 1.7-.5 2.6 0 .9.2 1.8.5 2.6.3.7.8 1.3 1.5 1.7s1.4.6 2.2.6c.9 0 1.7-.3 2.5-.8.3-.2.6-.5.8-.8s.4-.6.5-.9l-1.1-.3c0 .2-.2.4-.3.6",
    fill: "#ffffff",
    "data-color": 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.7 72.9c-.3-.2-.7-.4-1.1-.5-.4 0-.8-.1-1.2-.2-.5 0-1 0-1.5.2-.5.1-.9.4-1.3.7s-.7.8-.9 1.3l1.1.4c.1-.3.3-.5.5-.7q.3-.3.9-.6c.4-.1.8-.2 1.2-.2s.8 0 1.2.2c.3.2.6.4.8.7s.3.7.3 1.1v.2c0 .2-.1.4-.3.5-.3.1-.6.2-.9.2l-1.4.2c-.5 0-1 .2-1.5.3-.4.1-.8.3-1.2.5-.3.2-.6.5-.8.8q-.3.6-.3 1.2c0 .6.1 1.1.4 1.6.3.4.7.8 1.1 1 .5.2 1 .3 1.6.3.5 0 .9 0 1.4-.2.4-.2.7-.4 1-.6s.5-.5.6-.8V82h1.1v-6.5c0-.5 0-1.1-.3-1.6-.2-.4-.5-.7-.8-1m.3 5.4c0 .5-.1 1-.4 1.4-.2.4-.6.8-1 1-.5.3-1 .4-1.5.4-.4 0-.8 0-1.1-.2-.3-.1-.6-.3-.8-.6s-.3-.6-.3-1c0-.3 0-.7.3-.9q.3-.45.9-.6c.4-.2.9-.3 1.4-.3h.7c.3 0 .5 0 .8-.1.2 0 .4 0 .7-.2.2 0 .3-.1.4-.2v1.4Z",
    fill: "#ffffff",
    "data-color": 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M341 69.2V82h-1.2V69.2z",
    "data-color": 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m360.5 77.7-.3 1.2-.3 1.2c0 .3-.1.5-.2.8 0-.3-.1-.5-.2-.8 0-.4-.2-.8-.3-1.2 0-.4-.2-.8-.3-1.2l-2.3-8.5h-1.4l-2.3 8.5-.3 1.2c0 .4-.2.8-.3 1.2 0 .3-.1.6-.2.9 0-.3-.1-.6-.2-.9 0-.4-.2-.8-.3-1.2 0-.4-.2-.8-.3-1.2l-2.3-8.5h-1.2l3.5 12.8h1.5l2.3-8.6c.2-.6.3-1.2.4-1.7 0-.4.2-.8.3-1.2 0 .5.2.9.3 1.3.1.6.3 1.2.4 1.7l2.3 8.6h1.5l3.6-12.8h-1.3l-2.3 8.5Z",
    fill: "#ffffff",
    "data-color": 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.3 72.3c-.6 0-1.1.1-1.6.4s-.8.7-1 1.2v-1.5h-1.1V82h1.2v-6.2c0-.4.1-.9.3-1.3q.3-.6.9-.9c.4-.2.9-.3 1.3-.3h.7v-1.2h-.6",
    fill: "#ffffff",
    "data-color": 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.5 69c-.2 0-.4 0-.6.2-.3.3-.3.8 0 1.1s.9.3 1.2 0 .3-.8 0-1.1c-.2-.2-.4-.2-.6-.2",
    fill: "#ffffff",
    "data-color": 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M373.1 72.4V82h-1.2v-9.6z",
    "data-color": 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.9 81h-.3c-.3 0-.7 0-1-.3-.2-.3-.4-.7-.3-1.1v-6.3h2v-1h-2V70h-1.2v2.3h-1.4v1h1.4v6.4c0 .6.2 1.3.7 1.7s1.1.6 1.8.5h.5c.1 0 .3 0 .4-.1l-.2-1h-.3",
    fill: "#ffffff",
    "data-color": 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.8 69c-.2 0-.4 0-.6.2-.3.3-.3.8 0 1.1s.9.3 1.2 0 .3-.8 0-1.1c-.2-.2-.4-.2-.6-.2",
    fill: "#ffffff",
    "data-color": 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M382.5 72.4V82h-1.2v-9.6z",
    "data-color": 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.2 72.7c-1.2-.6-2.6-.5-3.7.2-.5.3-.8.8-1.1 1.3v-1.8h-1.1V82h1.2v-6c0-.5.1-1 .3-1.4s.6-.7 1-.9.9-.3 1.4-.3c.7 0 1.3.2 1.8.7s.7 1.2.7 1.9v6.1h1.2v-6.2c0-.7-.1-1.3-.4-1.9q-.45-.75-1.2-1.2",
    fill: "#ffffff",
    "data-color": 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.3 74.2h-.1c-.1-.3-.3-.6-.5-.9-.3-.3-.6-.6-.9-.8q-.75-.3-1.5-.3c-.7 0-1.5.2-2.1.6s-1.1 1-1.4 1.7c-.3.8-.5 1.7-.5 2.6s.2 1.7.5 2.5c.3.7.8 1.2 1.4 1.6s1.3.6 2 .6c.5 0 1 0 1.4-.3.4-.2.7-.4 1-.7l.6-.9h.1v2.2c0 .7-.2 1.5-.8 2-.6.4-1.3.7-2 .6-.5 0-.9 0-1.4-.2q-.45-.15-.9-.6c-.2-.2-.4-.5-.6-.7l-1 .6c.2.4.5.7.8 1 .4.3.8.5 1.3.7.6.2 1.1.3 1.7.3.7 0 1.4-.1 2.1-.4.6-.2 1.1-.6 1.4-1.2.4-.6.5-1.3.5-2v-9.9h-1.1zm-.4 4.9c-.2.5-.5 1-1 1.3s-1 .5-1.6.4c-.6 0-1.1-.1-1.6-.5-.4-.3-.8-.8-1-1.3-.2-.6-.4-1.3-.3-1.9 0-.7.1-1.3.3-1.9.2-.5.5-1 1-1.4 1-.7 2.2-.7 3.2 0 .4.4.8.8 1 1.4s.4 1.3.3 2c0 .7-.1 1.4-.3 2",
    fill: "#ffffff",
    "data-color": 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLogin);
export default __webpack_public_path__ + "static/media/logo-login.7ea2821cf134ccf1215614e2d868ad32.svg";
export { ForwardRef as ReactComponent };